import { Box } from '@mui/system'
import JobAdWindow from 'module/recruitment/pages/recruitment-create-job-ad/components/JobAdWindow'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import { useEffect, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useLocation } from 'react-router-dom'
import { getOneJobAds, updateJobAds } from 'services/api/modules/recruitment/job-advertisment'
import useOpenClose from 'services/hooks/useOpenClose'

const PublishDrafJobAds = () => {
  //error snackbar
  const errorSnackbar = useOpenClose(false)
  const saveSuccessSnackbar = useOpenClose(false)

  //set job id
  const location = useLocation()
  const id = location.state.id

  // set type of form
  const [typeOfForm, setTypeOfForm] = useState('')
  const handleTypeOfForm = (data) => {
    setTypeOfForm(data)
  }

  // CALL API
  const queryClient = useQueryClient()
  useEffect(() => {
    queryClient.invalidateQueries('getOneJobAds')
    queryClient.resetQueries('getOneJobAds')
  }, [])
  const {
    isLoading: getOneJobAdsIsLoading,
    error: getOneJobAdsError,
    data: getOneJobAdsData,
  } = useQuery(
    ['getOneJobAds', id],
    async () => {
      const { data } = await getOneJobAds(id)
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const {
    mutate: createJobPostingPublish,
    isError: createJobPostingPublishIsError,
    isSuccess: createJobPostingPublishIsSuccess,
    isLoading: createJobPostingPublishisLoading,
  } = useMutation((value) => updateJobAds(id, 'publish', value), {
    onError: (error) => {
      console.log(error)
      errorSnackbar.handleOpen()
    },
  })
  const {
    mutate: saveDraftMutate,
    isError: saveDraftIsError,
    isSuccess: saveDraftIsSuccess,
    isLoading: saveDraftisLoading,
  } = useMutation((value) => updateJobAds(id, 'update', value), {
    onSuccess: (response) => {
      saveSuccessSnackbar.handleOpen()
    },
    onError: (error) => {
      console.log(error)
      errorSnackbar.handleOpen()
    },
  })

  const handleUpdateJobAds = (e) => {
    //remove unwanted data before sending payload to api
    const data = e
    delete data.applications_count
    delete data.advertisement_status
    delete data.expired_date
    delete data.id
    delete data.onet_code
    delete data.job_level_name
    delete data.publish_at
    delete data.purchased_count
    delete data.update_count
    delete data.updated_at
    delete data.user_id
    delete data.urgency
    delete data.view_count
    delete data.academic_field
    delete data.created_at
    delete data.mobility
    delete data.qualification
    delete data.job_category_id
    delete data.course

    // set skill as array
    if (data.skill !== null && typeof data.skill !== 'object') {
      const updatedData = {
        ...data,
        skill: data.skill.split(','),
      }
      saveDraftMutate(updatedData)
    } else {
      const updatedData = {
        ...data,
      }
      saveDraftMutate(updatedData)
    }
  }

  const handleSubmit = (e) => {
    const data = e
    delete data.applications_count
    delete data.advertisement_status
    delete data.expired_date
    delete data.id
    delete data.onet_code
    delete data.job_level_name
    delete data.publish_at
    delete data.purchased_count
    delete data.update_count
    delete data.updated_at
    delete data.user_id
    delete data.urgency
    delete data.view_count
    delete data.academic_field
    delete data.created_at
    delete data.mobility
    delete data.qualification
    delete data.job_category_id
    delete data.course

    if (typeOfForm === 'publish') {
      if (data.skill !== null && typeof data.skill !== 'object') {
        const updatedData = {
          ...data,
          skill: data?.skill?.split(','),
        }
        createJobPostingPublish(updatedData)
      } else {
        const updatedData = {
          ...data,
        }
        createJobPostingPublish(updatedData)
      }
    } else if (typeOfForm === 'update') {
      if (data.skill !== null && typeof data.skill !== 'object') {
        const updatedData = {
          ...data,
          skill: data.skill.split(','),
        }
        saveDraftMutate(updatedData)
      } else {
        const updatedData = {
          ...data,
        }
        saveDraftMutate(updatedData)
      }
    }
  }
  // WILL REFACTOR THIS LEGACY CODE SOON!!!  !reminder(afi),
  return (
    <Box>
      <JobAdWindow
        formTitle={getOneJobAdsData?.position_title}
        handleTypeOfForm={handleTypeOfForm}
        publishJobAds={true}
        handleUpdateJobAds={handleUpdateJobAds}
        onSubmit={handleSubmit}
        createJobPostingPublishisLoading={createJobPostingPublishisLoading}
        createJobPostingPublishIsSuccess={createJobPostingPublishIsSuccess}
        draftIsLoading={getOneJobAdsIsLoading}
        initialValues={getOneJobAdsData}
      />

      {errorSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="error"
          TransitionComponent="slide"
          message="An error has occured"
          open={errorSnackbar.isOpen}
          handleClose={errorSnackbar.handleClose}
        />
      ) : null}
      {saveSuccessSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="success"
          TransitionComponent="slide"
          message="Job successfully saved"
          open={saveSuccessSnackbar.isOpen}
          handleClose={saveSuccessSnackbar.handleClose}
        />
      ) : null}
    </Box>
  )
}
export default PublishDrafJobAds
